// extracted by mini-css-extract-plugin
export default {"text":"axSdhL","positive":"bxSdhL","negative":"cxSdhL","neutral":"dxSdhL"};